import React from 'react'
import Layout from '../../../components/Layout'
import { Link } from "gatsby"

export default function Prijava() {

    return (
        <Layout>
            <main className="container px-6 font-medium text-lg text-primary">
                <h1 className="text-5xl mt-16 mb-8 lg:text-6xl lg:my-16 xl:text-7xl xl:my-20 mb-5">Razpis 2021<span className="text-xs bg-primary px-2 py-1 text-white ml-2">COVID-19</span></h1>
                <nav className="mb-10 lg:-mt-10 xl:mb-20 lg:text-2xl lg:flex items-center">
                    <p>Pojdi na: </p>
                    <ul className="lg:flex">
                        <li className="lg:pl-2 lg:mt-0 mt-1"><a className="border-b-2 border-primary" href="#osnovne">Osnovne informacije</a><span className="hidden lg:inline-block">, </span></li>
                        <li className="lg:pl-2 lg:mt-0 mt-1"><a className="border-b-2 border-primary" href="#potek">Potek tekmovanja</a><span className="hidden lg:inline-block">, </span></li>
                        <li className="lg:pl-2 lg:mt-0 mt-1"><a className="border-b-2 border-primary" href="#kategorije">Kategorije</a><span className="hidden lg:inline-block">, </span></li>
                        <li className="lg:pl-2 lg:mt-0 mt-1"><a className="border-b-2 border-primary" href="#potrdila">Potrdila</a><span className="hidden lg:inline-block">, </span></li>
                        <li className="lg:pl-2 lg:mt-0 mt-1"><a className="border-b-2 border-primary" href="#prijava">Prijava</a></li>
                    </ul>
                </nav>
                <section className=" lg:text-xl text-lg text-container">
                    <p className="pb-6">
                        ZOT bo v <strong>soboto 27. 3. 2021</strong>, kar je glede na trenutne razmere izvedljivo. Še vedno pa smo odvisni od epidemiološke situacije in ukrepov, zato bomo ta datum dokončno potrdili 13. 3. 2021. Prijave so odprte in bodo odprte do tedna pred tekmovanjem.
                    </p>

                </section>
                <section className="mt-5 text-container">
                    <h2 id="osnovne" className="pb-3 lg:pb-6 text-3xl lg:text-4xl xl:text-5xl">Osnovne informacije</h2>
                    <p className="pb-6">
                        Kdaj: <span className="border-b-2 border-primary">27. marec 2021</span><br />
                        <ul className="list-disc ml-5">
                            <li>GG kategorija: 9.00-12.00</li>
                            <li>PP+ kategorija: 15.00-18.00</li>
                        </ul>
                    </p>

                    <p className="pb-6">
                        Kje: <span className="border-b-2 border-primary">v lokalnih taborniških prostorih ekipe in lokalni šumi</span><br />
                    </p>

                    <p className="pb-6">
                        Prijave: <span className="border-b-2 border-primary">prijave so odprte in bodo odprte do tedna pred tekmovanjem</span><br />
                    </p>

                    <p className="pb-6">
                        Pomoč: <a href="mailto:zot.prijave@gmail.com"><span className="border-b-2 border-primary">zot.prijave@gmail.com</span></a>
                    </p>

                    <p className="pb-6">Ali bomo tekmovanje izvedeli v določenem terminu, vas bomo obvestili najkasneje do 13. marec 2021. Druge informacije (štartne številke, večerni program, ...) bodo prejeli vodje ekip v tednu pred tekmovanjem.
</p>

                </section>

                <section className="mt-5 text-container">
                    <h2 id="potek" className="pb-3 lg:pb-6 text-3xl lg:text-4xl xl:text-5xl">
                        Potek tekmovanja</h2>
                    <p className="pb-6">
                    ZOT bo letos potekal na nekoliko drugačen način. Ekipe se boste preizkusile v zabavnih nalogah, ki jih boste prejeli ob začetku tekmovanja. Taborniške naloge bodo preverjale vaše splošno taborniško znanje na večih področjih, netaborniške naloge pa bodo v ekipi vzbudile zabavno vzdušje in spodbudile povezovanje ter team building. Nekatere naloge boste opravljali tudi zunaj. Letos bo vsaka ekipa ZOT doživela na svoji lokaciji, v svojem kraju. Vsa komunikacija z organizatorji tekmovanja bo potekala preko spletne platforme. Kot dokazno gradivo za opravljene naloge boste našim kontrolorjem pošiljali večinoma fotografije in videoposnetke, kontrolorji pa vam bodo naknadno sporočili, kako so ocenili vašo nalogo. Čeprav na drugačen način, kot smo ga vajeni, skušamo letos ohraniti vzdušje ZOTa, kot ga vsi poznamo.
                    </p>
                    <p className="pb-6">
                    Potrebujejo: ekipo do 5 članov (GGji še vodnika), pametne telefone za fotografije in videoposnetke, po možnosti tudi računalnik, povprečno internetno povezavo, iznajdljivost, kreativnost in dobro voljo.
                    </p>
                </section>

                <section className="mt-5 text-container">
                    <h2 id="kategorije" className="pb-3 lg:pb-6 text-3xl lg:text-4xl xl:text-5xl">
                        Kategorije</h2>
                    <p className="pb-6">
                        Ekipe tekmovalcev bodo razvrščene v kategorije glede na starost:
                    </p>
                    <ul className="list-disc ml-5 pb-6">
                        <li><span className="border-b-2 border-primary">Gozdovnice in gozdovniki (gg)</span> - letnik rojstva: 2006 - 2009<br />
                        <p className="pb-6">Z GG ekipami mora biti prisoten vodnik ali drug polnoleten član rodu s plačano članarino.</p></li>
                        <li><span className="border-b-2 border-primary">Popotniki, popotnice, raziskovalci, raziskovalke, grče in grčice (PP+)</span> - letnik rojstva: 2005 in starejši</li>
                    </ul>
                    <p className="pb-6">
                    V GG kategoriji je lahko en član ekipe za eno leto mlajši ali starejši od kategorije ekipe.
                    </p>
                    <p className="pb-6">
                    V kategoriji PP+ lahko tekmujejo le tekmovalci, ki bodo v koledarskem letu dopolnili 16 let. Navzgor ni omejitve.

                    </p>
                    <p className="pb-6">
                    Ekipa šteje največ 5 članov. Če so v ekipi štirje tekmovalci, ekipa tekmuje brez olajšav. Ekipa s tremi tekmovalci tekmuje izven konkurence. Vseeno so manj številčne ekipe tudi dobrodošle. :)
                    </p>
                </section>

                <section className="mt-5 text-container">
                    <h2 id="potrdila" className="pb-3 lg:pb-6 text-3xl lg:text-4xl xl:text-5xl">
                        Potrdila</h2>
                    <p className="pb-6">
                    Podpisana potrdila naj celotna ekipa hkrati pošlje fotografirana ali skenirana na ZOTov mail (zot.prijave@gmail.com) najkasneje do 22. marca 2021.
                    </p>
                    <p className="pb-6">
                    Tekmovalci morajo na tekmovanju imeti podpisano potrdilo o sodelovanju in upoštevanju vladnih ukrepov zaradi epidemije COVID-19. Brez slednjega udeležba na tekmovanju ni mogoča. Mladoletnim tekmovalcem podpiše izjavo zakoniti zastopnik.
                    </p>
                    <a target="_blank" className="border-b-2 border-primary" href="https://drive.google.com/drive/folders/1UggNjRqd610H4bHXFXnlHuXUKkifCwmi?usp=sharing">{">> Tekmovalna izjava <<"}</a>
                </section>

                <section id="prijava" className="mt-16 text-container">
                    <Link className="py-3 block text-center text-3xl text-white bg-primary" to="/prijava">Prijavi ekipo</Link>
                </section>
            </main>
        </Layout>
    );
}